import { buttonVariants } from "@/components/atoms/buttons";
import { Graphics } from "@/components/graphics";
import { __, getPermalink } from "@/lib/i18n/functions";
import { cn } from "@/lib/utils";
import Link from "next/link";

type UserConfirmProps = {
  resolution: Resolution;
};

const UserConfirm = ({ resolution }: UserConfirmProps) => {
  const { locale } = resolution;

  return (
    <div key="step3" className="mx-auto mt-14 w-full max-w-[672px] max-sm:my-[164px]">
      <div className="font-cabinet-grotesk space-y-6">
        <div className="flex items-center gap-5">
          <Graphics.authCheck />
          <div className="space-y-2.5">
            <h2 className="text-2xl font-bold">{__("Email Address Verified !", locale)}</h2>
            <p className="text-primary-light">{__("Your account is officially created.", locale)}</p>
          </div>
        </div>
        <Link href={getPermalink(locale, "login")} className={cn(buttonVariants(), "h-11 w-full cursor-pointer")}>
          {__("Login", locale)}
        </Link>
      </div>
    </div>
  );
};

export default UserConfirm;
